/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  Text as EditableText,
  TextProps,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  ForeignObject as SVG_ForeignObject,
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const ForeignObject = Animated.createAnimatedComponent(SVG_ForeignObject);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
import FontList from "react-native-font-list";
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="144" height="40" viewBox="0 0 144 40" fill="none"> <desc id="IMP.BLUE">{"#CreditAvailable":{"type":"SELECTOR","constraint":"xMinYMin meet","width":144,"height":40},"#Line_2053":{"type":"SELECTOR","constraint":"xMidYMid meet","width":117,"height":0},"#available_20credit":{"type":"SELECTOR","constraint":"xMidYMid meet","width":103,"height":10},"#CreditCardSmall":{"type":"SELECTOR","constraint":"none","width":26,"height":17.875},"#CreditCard":{"type":"SELECTOR","constraint":"none","width":26,"height":17.875},"#Vector":{"type":"SELECTOR","constraint":"none","width":2.4375,"height":2.4375},"transforms":{"CreditCardSmall":[{"name":"CreditCardSmall","relativeTransforms":[[1,0,16],[0,1,4]],"rotation":0,"instanceParentName":"CreditCardSmall","isInstanceParent":true,"isInstanceChild":false,"width":26,"height":17.875},{"name":"CreditCardSmall","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"CreditCardSmall","isInstanceParent":true,"isInstanceChild":true,"width":26,"height":17.875}],"CreditCard":[{"name":"CreditCard","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"CreditCardSmall","isInstanceParent":false,"isInstanceChild":true,"width":26,"height":17.875}],"Vector":[{"name":"Vector","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"CreditCardSmall","isInstanceParent":false,"isInstanceChild":true,"width":26,"height":17.875},{"name":"Vector","relativeTransforms":[[1,0,4.0625],[0,1,11.375]],"rotation":0,"instanceParentName":"CreditCardSmall","isInstanceParent":false,"isInstanceChild":true,"width":2.4375,"height":2.4375}]},"tProps":{"type":"PROPS","_243_2C850?":{"style?":"tTextStyle","textOptions?":"TextProps","innerHTML?":"string"},"onAnimationComplete?":"() => void","myAmount?":{"style?":"tTextStyle","textOptions?":"TextProps","innerHTML?":"string"},"myLabel?":{"style?":"tTextStyle","textOptions?":"TextProps","innerHTML?":"string"}},"#_243_2C850":{"type":"SELECTOR","tspan":{"innerHTML":"props?._243_2C850?.innerHTML ?? \"$3,850 \"","x":"48","y":"-2","width":"94","height":"30"},"constraint":"xMidYMid meet","width":94,"height":30},"#myAmount":{"type":"SELECTOR","tspan":{"innerHTML":"props?.myAmount?.innerHTML ?? \"$3,850 \"","x":"48","y":"-2","width":"94","height":"30"},"constraint":"xMidYMid meet","width":94,"height":30},"#myLabel":{"type":"SELECTOR","tspan":{"innerHTML":"props?.myLabel?.innerHTML ?? \"available credit\"","x":"20","y":"27","width":"103","height":"10"},"constraint":"xMidYMid meet","width":103,"height":10}}</desc>
 * <g id="CreditAvailable">
 * <path d="M0 20C0 8.95431 8.95431 0 20 0H124C135.046 0 144 8.95431 144 20V20C144 31.0457 135.046 40 124 40H20C8.95431 40 0 31.0457 0 20V20Z" fill="white"/>
 * <line id="Line 53" x1="13" y1="23.5" x2="130" y2="23.5" stroke="#EDD4CB"/>
 * <text id="myLabel" fill="black" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="8" font-weight="bold" letter-spacing="0.15em"><tspan x="26.0078" y="34.824">AVAILABLE CREDIT</tspan></text>
 * <text id="myAmount" fill="black" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.15em"><tspan x="48" y="18.06">$3,850 </tspan></text>
 * <g id="CreditCardSmall">
 * <g id="CreditCardSmall_2">
 * <path id="CreditCard" fill-rule="evenodd" clip-rule="evenodd" d="M18.8438 4H39.1562C40.7243 4 42 5.27573 42 6.84375V19.0312C42 20.5993 40.7243 21.875 39.1562 21.875H18.8438C17.2757 21.875 16 20.5993 16 19.0312V6.84375C16 5.27573 17.2757 4 18.8438 4ZM39.1562 5.625H18.8438C18.1718 5.625 17.625 6.17176 17.625 6.84375V8.46875H40.375V6.84375C40.375 6.17176 39.8282 5.625 39.1562 5.625ZM18.8438 20.25H39.1562C39.8282 20.25 40.375 19.7032 40.375 19.0312V10.0938H17.625V19.0312C17.625 19.7032 18.1718 20.25 18.8438 20.25ZM20.875 17.8125H21.6875C22.1362 17.8125 22.5 17.4487 22.5 17V16.1875C22.5 15.7388 22.1362 15.375 21.6875 15.375H20.875C20.4263 15.375 20.0625 15.7388 20.0625 16.1875V17C20.0625 17.4487 20.4263 17.8125 20.875 17.8125Z" fill="black"/>
 * </g>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#CreditAvailable": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 144,
 * 		"height": 40
 * 	},
 * 	"#Line_2053": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMidYMid meet",
 * 		"width": 117,
 * 		"height": 0
 * 	},
 * 	"#available_20credit": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMidYMid meet",
 * 		"width": 103,
 * 		"height": 10
 * 	},
 * 	"#CreditCardSmall": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 26,
 * 		"height": 17.875
 * 	},
 * 	"#CreditCard": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 26,
 * 		"height": 17.875
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 2.4375,
 * 		"height": 2.4375
 * 	},
 * 	"transforms": {
 * 		"CreditCardSmall": [
 * 			{
 * 				"name": "CreditCardSmall",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						16
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						4
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "CreditCardSmall",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 26,
 * 				"height": 17.875
 * 			},
 * 			{
 * 				"name": "CreditCardSmall",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "CreditCardSmall",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": true,
 * 				"width": 26,
 * 				"height": 17.875
 * 			}
 * 		],
 * 		"CreditCard": [
 * 			{
 * 				"name": "CreditCard",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "CreditCardSmall",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 26,
 * 				"height": 17.875
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "CreditCardSmall",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 26,
 * 				"height": 17.875
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						4.0625
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						11.375
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "CreditCardSmall",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.4375,
 * 				"height": 2.4375
 * 			}
 * 		]
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"_243_2C850?": {
 * 			"style?": "tTextStyle",
 * 			"textOptions?": "TextProps",
 * 			"innerHTML?": "string"
 * 		},
 * 		"onAnimationComplete?": "() => void",
 * 		"myAmount?": {
 * 			"style?": "tTextStyle",
 * 			"textOptions?": "TextProps",
 * 			"innerHTML?": "string"
 * 		},
 * 		"myLabel?": {
 * 			"style?": "tTextStyle",
 * 			"textOptions?": "TextProps",
 * 			"innerHTML?": "string"
 * 		}
 * 	},
 * 	"#_243_2C850": {
 * 		"type": "SELECTOR",
 * 		"tspan": {
 * 			"innerHTML": "props?._243_2C850?.innerHTML ?? \"$3,850 \"",
 * 			"x": "48",
 * 			"y": "-2",
 * 			"width": "94",
 * 			"height": "30"
 * 		},
 * 		"constraint": "xMidYMid meet",
 * 		"width": 94,
 * 		"height": 30
 * 	},
 * 	"#myAmount": {
 * 		"type": "SELECTOR",
 * 		"tspan": {
 * 			"innerHTML": "props?.myAmount?.innerHTML ?? \"$3,850 \"",
 * 			"x": "48",
 * 			"y": "-2",
 * 			"width": "94",
 * 			"height": "30"
 * 		},
 * 		"constraint": "xMidYMid meet",
 * 		"width": 94,
 * 		"height": 30
 * 	},
 * 	"#myLabel": {
 * 		"type": "SELECTOR",
 * 		"tspan": {
 * 			"innerHTML": "props?.myLabel?.innerHTML ?? \"available credit\"",
 * 			"x": "20",
 * 			"y": "27",
 * 			"width": "103",
 * 			"height": "10"
 * 		},
 * 		"constraint": "xMidYMid meet",
 * 		"width": 103,
 * 		"height": 10
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  _243_2C850?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
  onAnimationComplete?: () => void;
  myAmount?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
  myLabel?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const CreditAvailable = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  _243_2C850?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
  onAnimationComplete?: () => void;
  myAmount?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
  myLabel?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
}): JSX.Element => {
  const {
    style = {
      width: 144,
      height: 40,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 144 40"
        >
          <G id="CreditAvailable">
            <Path
              d="M0 20C0 8.95431 8.95431 0 20 0H124C135.046 0 144 8.95431 144 20V20C144 31.0457 135.046 40 124 40H20C8.95431 40 0 31.0457 0 20V20Z"
              fill="white"
              id="CreditAvailable_elem0"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            <Svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 144 40">
              <Path
                id="Line_2053"
                stroke="#EDD4CB"
                d="M13 23.5 L130 23.5 M13 130z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <ForeignObject key={JSON.stringify(props?.myLabel)} x={20} y={27} width={103} height={10}>
              <View
                style={{
                  height: 10,
                  width: 103,
                }}
              >
                <EditableText
                  {...props?.myLabel?.textOptions}
                  style={[
                    {
                      textAlign: "center",
                      fontSize: 8,
                      fontWeight: "700",
                      color: "black",
                      fontFamily: checkFont("Raleway"),
                      letterSpacing: 1,
                    },
                    props?.myLabel?.style,
                  ]}
                >
                  {props?.myLabel?.innerHTML ?? "AVAILABLE CREDIT"}
                </EditableText>
              </View>
            </ForeignObject>
            <ForeignObject key={JSON.stringify(props?.myAmount)} x={48} y={-2} width={94} height={30}>
              <View
                style={{
                  height: 30,
                  width: 94,
                }}
              >
                <EditableText
                  {...props?.myAmount?.textOptions}
                  style={[
                    {
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "black",
                      fontFamily: checkFont("Raleway"),
                    },
                    props?.myAmount?.style,
                  ]}
                >
                  {props?.myAmount?.innerHTML ?? "$3,850 "}
                </EditableText>
              </View>
            </ForeignObject>
            <Svg preserveAspectRatio="none" viewBox="0 0 144 40">
              <G id="CreditCardSmall">
                <G id="CreditCardSmall_2">
                  <Svg preserveAspectRatio="none" viewBox="0 0 144 40">
                    <Path
                      id="CreditCard"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.8438 4H39.1562C40.7243 4 42 5.27573 42 6.84375V19.0312C42 20.5993 40.7243 21.875 39.1562 21.875H18.8438C17.2757 21.875 16 20.5993 16 19.0312V6.84375C16 5.27573 17.2757 4 18.8438 4ZM39.1562 5.625H18.8438C18.1718 5.625 17.625 6.17176 17.625 6.84375V8.46875H40.375V6.84375C40.375 6.17176 39.8282 5.625 39.1562 5.625ZM18.8438 20.25H39.1562C39.8282 20.25 40.375 19.7032 40.375 19.0312V10.0938H17.625V19.0312C17.625 19.7032 18.1718 20.25 18.8438 20.25ZM20.875 17.8125H21.6875C22.1362 17.8125 22.5 17.4487 22.5 17V16.1875C22.5 15.7388 22.1362 15.375 21.6875 15.375H20.875C20.4263 15.375 20.0625 15.7388 20.0625 16.1875V17C20.0625 17.4487 20.4263 17.8125 20.875 17.8125Z"
                      fill="black"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                  </Svg>
                </G>
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 144 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          d="M0 20C0 8.95431 8.95431 0 20 0H124C135.046 0 144 8.95431 144 20V20C144 31.0457 135.046 40 124 40H20C8.95431 40 0 31.0457 0 20V20Z"
          fill="white"
          id="CreditAvailable_elem0"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 144 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Line_2053"
          stroke="#EDD4CB"
          d="M13 23.5 L130 23.5 M13 130z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 144 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <ForeignObject key={JSON.stringify(props?.myLabel)} x={20} y={27} width={103} height={10}>
          <View
            style={{
              height: 10,
              width: 103,
            }}
          >
            <EditableText
              {...props?.myLabel?.textOptions}
              style={[
                {
                  textAlign: "center",
                  fontSize: 8,
                  fontWeight: "bold",
                  color: "black",
                  fontFamily: checkFont("Raleway"),
                },
                props?.myLabel?.style,
              ]}
            >
              {props?.myLabel?.innerHTML ?? "available credit"}
            </EditableText>
          </View>
        </ForeignObject>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 144 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <ForeignObject key={JSON.stringify(props?.myAmount)} x={48} y={-2} width={94} height={30}>
          <View
            style={{
              height: 30,
              width: 94,
            }}
          >
            <EditableText
              {...props?.myAmount?.textOptions}
              style={[
                {
                  fontSize: 20,
                  fontWeight: "bold",
                  color: "black",
                  fontFamily: checkFont("Raleway"),
                },
                props?.myAmount?.style,
              ]}
            >
              {props?.myAmount?.innerHTML ?? "$3,850 "}
            </EditableText>
          </View>
        </ForeignObject>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 144 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="CreditCardSmall">
          <G id="CreditCardSmall_2">
            <Path
              id="CreditCard"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.8438 4H39.1562C40.7243 4 42 5.27573 42 6.84375V19.0312C42 20.5993 40.7243 21.875 39.1562 21.875H18.8438C17.2757 21.875 16 20.5993 16 19.0312V6.84375C16 5.27573 17.2757 4 18.8438 4ZM39.1562 5.625H18.8438C18.1718 5.625 17.625 6.17176 17.625 6.84375V8.46875H40.375V6.84375C40.375 6.17176 39.8282 5.625 39.1562 5.625ZM18.8438 20.25H39.1562C39.8282 20.25 40.375 19.7032 40.375 19.0312V10.0938H17.625V19.0312C17.625 19.7032 18.1718 20.25 18.8438 20.25ZM20.875 17.8125H21.6875C22.1362 17.8125 22.5 17.4487 22.5 17V16.1875C22.5 15.7388 22.1362 15.375 21.6875 15.375H20.875C20.4263 15.375 20.0625 15.7388 20.0625 16.1875V17C20.0625 17.4487 20.4263 17.8125 20.875 17.8125Z"
              fill="black"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(CreditAvailable);
